import { Type } from 'class-transformer'
import { IsDate, IsDefined, IsNumber, IsOptional, IsString, ValidateNested } from 'class-validator'
import { TemplateDto } from '@decet/templates-shared'
import { WhastAppMessageMessagesTextDto } from './whatsapp.dto'

export class CRMMessagePlataformaDto {
  @IsNumber()
  id!: number

  @IsString()
  descripcion!: string
}

export class CRMMessageCuentaDto {
  @IsOptional()
  @IsNumber()
  id?: number

  @IsOptional()
  @IsString()
  apikey?: string

  @IsOptional()
  @IsString()
  identificador?: string

  @IsOptional()
  @IsString()
  token?: string
}

export class CRMMessageDtoAttachmentDto {
  @IsString()
  id!: string

  @IsString()
  type!: string

  @IsString()
  url!: string
}

export class CRMMessageContentDto {
  @IsString()
  id!: string

  @IsOptional()
  @IsString()
  subject?: string

  @Type(() => WhastAppMessageMessagesTextDto)
  @ValidateNested()
  text?: WhastAppMessageMessagesTextDto

  @ValidateNested({ each: true })
  attachments!: CRMMessageDtoAttachmentDto[]
}

export class CRMContact {
  @IsOptional()
  @IsNumber()
  id?: number

  @IsString()
  nombre!: string

  @IsString()
  identificador!: string
}

export class CRMMessageDto {
  @IsOptional()
  @ValidateNested()
  agente?: any

  @IsDefined()
  @Type(() => CRMMessagePlataformaDto)
  @ValidateNested()
  plataforma!: CRMMessagePlataformaDto

  @IsDefined()
  @Type(() => CRMMessageCuentaDto)
  @ValidateNested()
  cuenta!: CRMMessageCuentaDto

  @IsDate()
  @Type(() => Date)
  timestamp!: Date

  @IsDefined()
  @Type(() => CRMMessageContentDto)
  @ValidateNested()
  message!: CRMMessageContentDto

  @IsOptional()
  @Type(() => TemplateDto)
  @ValidateNested()
  template?: TemplateDto

  @Type(() => CRMContact)
  @ValidateNested()
  contact!: CRMContact
  @IsOptional()
  etiquetas?: string[]

  @IsOptional()
  estatusMensaje?: number
  // estatusMensaje?: number
}

export class CRMMessageDtoResultado {
  error!: string
  data!: CRMMessageDto
}
